import React, { useState } from 'react'
import './advanceFilter.css'
import { MenuItem, Menu } from '@mui/material'
import { Close } from '@mui/icons-material'
import { useTranslation } from "react-i18next"
import { MSelect, MInputTextField, MCheckBox, MButton } from '../../../M_Components'
import PropTypes from 'prop-types'

export function AdvanceFilter({ metaPair, metaType, onAddMetaPair,
    onSubmitFilters, onDeleteFilter, onDeleteAllFilters, anchorAF,
    setAnchorAF, onSaveFilter, views, onToasts, color, colorOptions,
    removeColumns, removeFilters }) {
        
    const { t } = useTranslation()
    const [showInput, setShowInput] = useState(false)
    const [newView, setNewView] = useState('')
    const [selectedValue, setSelectedValue] = useState('')
    const [openSave, setOpenSave] = useState(false)
    const openAdvancedFilterMenu = Boolean(anchorAF)

    const addFilter = (name, display, type, operation, value) => {
        const filter = {
            name: name,
            display: display,
            type: type,
            operation: operation,
            value: value
        }
        onAddMetaPair(filter)
    }

    const checkUncheck = (name, type, display) => {
        if (!name) return
        let tempBool = false
        if (metaPair.length) {
            metaPair.forEach(element => {
                if (element.name === name) {
                    tempBool = true
                }
            })
            if (tempBool) return deleteFilter(name)
            if (type === 'boolean') return addFilter(name, display, type, 'Equals', false)
            if (type === 'int32' || colorOptions?.get(name) || name.includes('Status')) return addFilter(name, display, type, 'Equals', '')
            return addFilter(name, display, type, 'Contains', '')
        } else {
            if (type === 'boolean') return addFilter(name, display, type, 'Equals', false)
            if (type === 'int32' || colorOptions?.get(name) || name.includes('Status')) return addFilter(name, display, type, 'Equals', '')
            return addFilter(name, display, type, 'Contains', '')
        }
    }

    const deleteFilter = (filterName) => {
        onDeleteFilter(filterName)
        onToasts('success', '', t("FilterDeleted"))
    }

    const deleteAllFilters = () => {
        onDeleteAllFilters()
        setOpenSave(false)
        setShowInput(false)
        onToasts('success', '', t("ClearedFilters"))
        handleCloseAdvancedFilterMenu()
    }

    const submitFilters = () => {
        onSubmitFilters()
        onToasts('success', '', t("FilterCreated"))
        handleCloseAdvancedFilterMenu()
    }

    const saveFilters = () => {
        if (showInput && newView !== '') {
            onSaveFilter(newView)
            setOpenSave(false)
            setShowInput(false)
            onToasts('success', '', `${newView} ${t("ViewCreated")}`)
        } else if (selectedValue !== 'Create New' && selectedValue !== '') {
            onSaveFilter(selectedValue)
            onToasts('success', '', `${selectedValue} ${t("ViewEdited")}`)
        }
        else {
            onToasts('error', '', `${t("ViewNameError")}`)
        }
    }

    const selectedColumns = () => {
        const aux = []
        metaPair.forEach(element => {
            aux.push(element.name)
        })
        return aux

    }

    const handleCloseAdvancedFilterMenu = () => {
        setAnchorAF(null)
    }

    const optionsMetaType = () => {
        const tempArray = []
        metaType.forEach(element => {
            if ((element.metaType === "string" || element.metaType === "int32" || element.metaType === "boolean") && !element.metaIsList && !removeFilters?.includes(element.metaName)) {
                tempArray.push({ label: element.metaDisplay, value: element.metaName, metaName: element.metaName, metaType: element.metaType, metaDisplay: element.metaDisplay })
            }
        })
        return tempArray
    }

    const optionsSelectedValue = () => {
        const tempArray = []

        Object.keys(Object.fromEntries(views)).forEach(element => {
            tempArray.push({ label: element, value: element })
        })
        tempArray.push({ label: t("CreateNewView"), value: 'Create New' })

        return tempArray
    }

    function selectItemTemplate(elem) {
        return (
            <div style={{
                display: 'flex',
                padding: '0px 5px',
                fontWeight: 'bolder',
                color: 'white',
                borderRadius: '4px',
                width: '100%',
                fontSize: '0.7rem',
                backgroundColor: elem.severity
            }} >
                {elem.name}
            </div>
        )
    }

    function filtersInputs(element) {
        if (!removeColumns?.includes(element.name)) {

            if (colorOptions?.get(element.name) || element.name === 'Status') {
                return <>
                    <div style={{ margin: '5px', width: '30%' }}>
                        <MSelect
                            secondColor={"var(--color-black)"}
                            color={color}
                            label={t("Filter")}
                            value={element.operation}
                            onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                            options={[{ label: t("EqualsTo"), value: 'Equals' }]}
                        />
                    </div>
                    <div style={{ margin: '5px', width: '30%' }}>
                        <MSelect
                            secondColor={"var(--color-black)"}
                            color={color}
                            label={t("Value")}
                            value={element.value}
                            onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.value)}
                            itemTemplate={selectItemTemplate}
                            options={colorOptions?.get(element.name)?.map(elem => {
                                return { label: elem.name, value: elem.value, severity: elem.severity, name: elem.name }
                            })}
                        />
                    </div>
                </>
            }
            if (element.type === 'string') {
                return <>
                    <div style={{ margin: '5px', width: '30%' }}>
                        <MSelect
                            secondColor={"var(--color-black)"}
                            color={color}
                            label={t("Filter")}
                            value={element?.operation}
                            onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                            options={[{ label: t("Contains"), value: 'Contains' }, { label: t("EqualsTo"), value: 'Equals' }]}
                        />
                    </div>
                    <div style={{ margin: '5px', width: '30%' }}>
                        <MInputTextField
                            secondColor={"var(--color-black)"}
                            color={color}
                            label={`${t('Value')}`}
                            type={"text"}
                            onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.value)}
                            value={element.value}
                        />
                    </div>
                </>
            }
            if (element.type === 'int32') {
                return <>
                    <div style={{ margin: '5px', width: '30%' }}>
                        <MSelect
                            secondColor={"var(--color-black)"}
                            color={color}
                            value={element?.operation}
                            label={t("Filter")}
                            onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                            options={[{ label: t("EqualsTo"), value: 'Equals' }, { label: t("GreaterThan"), value: 'Greater' }, { label: t("LesserThan"), value: 'Lesser' }]}
                        />
                    </div>
                    <div style={{ margin: '5px', width: '30%' }}>
                        <MInputTextField
                            secondColor={"var(--color-black)"}
                            color={color}
                            label={`${t('Value')}`}
                            type={"number"}
                            value={element.value}
                            onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.value)}
                        />
                    </div>
                </>
            }
            if (element.type === 'boolean') {
                return <>
                    <div style={{ margin: '5px', width: '30%' }}>
                        <MSelect
                            secondColor={"var(--color-black)"}
                            color={color}
                            value={element?.operation}
                            label={t("Filter")}
                            onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                            options={[{ label: t("EqualsTo"), value: 'Equals' }]}
                        />
                    </div>
                    <div style={{ margin: '5px', width: '30%', justifyContent: 'center', display: 'flex' }}>
                        <MCheckBox
                            checked={element.value || false}
                            onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.checked)}
                        />
                    </div>
                </>
            }
            return null
        }
        return (
            <>
                <div style={{ margin: '5px', width: '30%' }}>
                    <MSelect
                        secondColor={"var(--color-black)"}
                        color={color}
                        label={t("Filter")}
                        value={element.operation}
                        onChange={(e) => addFilter(element.name, element.display, element.type, e.target.value, element.value)}
                        options={[{ label: t("Contains"), value: 'Contains' }]}
                    />
                </div>
                <div style={{ margin: '5px', width: '30%' }}>
                    <MInputTextField
                        secondColor={"var(--color-black)"}
                        color={color}
                        label={`${t('Value')}`}
                        type={"text"}
                        onChange={(e) => addFilter(element.name, element.display, element.type, element.operation, e.target.value)}
                        value={element.value}
                    />
                </div>
            </>
        )
    }

    return (
        <Menu
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            anchorEl={anchorAF}
            open={openAdvancedFilterMenu}
            onClose={handleCloseAdvancedFilterMenu}
            MenuListProps={{ disablePadding: true }}
            className="organizeMenuSearch"
            slotProps={{
                paper: { sx: { marginTop: '1px' } }
            }}
            variant={'menu'}
        >
            <div className='stickyTop'>
                {/* <MenuItem className='menuSearchFilters' disableRipple={true} onClick={() => { setOpen(prev => !prev) }} > */}
                <MenuItem className='menuSearchFilters' disableRipple={true}>
                    <MSelect
                        secondColor={"var(--color-black)"}
                        color={color}
                        label={t("SelectedColumns")}
                        multiple
                        value={selectedColumns()}
                        onClick={(element) => { checkUncheck(element.metaName, element.metaType, element.metaDisplay) }}
                        options={optionsMetaType()}
                    />
                </MenuItem>
            </div>
            <div className='Filters'>
                {metaPair.length ? metaPair.map((element, index) => (
                    <MenuItem className='itemContainer' key={element?.name} disableRipple={true}>
                        <h4 style={{ width: '40%' }}>{element.display}</h4>
                        {filtersInputs(element)}
                        <div className="closeIcon">
                            <MButton
                                icon={<Close />}
                                onClick={() => deleteFilter(element.name)}
                                hoverEffect
                                none
                                marginNone
                            />
                        </div>
                    </MenuItem>
                )) :
                    <h4 className='spanItems'>{t("NoFilters")}</h4>
                }
            </div>
            <div className='stickyBot'>
                <MenuItem className='menuItemButtons ' disableRipple={true}>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%' }}>
                        <MButton
                            icon={<i className="pi pi-sync" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                            normal
                            hoverEffect
                            labelColor={'var(--color-white)'}
                            backgroundColor={'var(--color-red)'}
                            onClick={() => deleteAllFilters()}
                            label={`${t('ClearFilters')}`}
                        />
                        <MButton
                            icon={<i className="pi pi-check" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                            normal
                            hoverEffect
                            labelColor={'var(--color-white)'}
                            backgroundColor={'var(--color-green)'}
                            onClick={() => submitFilters()}
                            label={`${t('SubmitFilters')}`}
                        />
                        {metaPair.length ?
                            <div id='saveMenu'>
                                <MButton
                                    icon={<i className="pi pi-plus-circle" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                                    hoverEffect
                                    normal
                                    label={`${t('Add')}`}
                                    labelColor={'var(--color-white)'}
                                    backgroundColor={color}
                                    onClick={() => {
                                        setSelectedValue('')
                                        setShowInput(false)
                                        setOpenSave(!openSave)
                                    }}
                                />
                            </div>
                            : ''
                        }
                    </div>
                </MenuItem>
                {openSave ?
                    <MenuItem className='removeHover menuCreateView' disableRipple={true} >
                        {metaPair.length ?
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: '100%' }}>
                                <div style={{ width: '80%' }}>
                                    <MSelect
                                        secondColor={"var(--color-black)"}
                                        color={color}
                                        label={t('Save')}
                                        value={selectedValue}
                                        options={optionsSelectedValue()}
                                        onClick={(el) => {
                                            if (el.value === 'Create New' || "") {
                                                setSelectedValue('Create New')
                                                setShowInput(true)
                                            } else {
                                                setSelectedValue(el.value)
                                                setShowInput(false)
                                            }
                                        }}
                                    />
                                </div>
                                <MButton
                                    icon={<i className="pi pi-save" style={{ fontSize: '1rem', color: 'var(--color-white)' }}></i>}
                                    normal
                                    hoverEffect
                                    label={t('Save')}
                                    backgroundColor={'var(--color-green)'}
                                    onClick={() => saveFilters()}
                                    labelColor={'var(--color-white)'}
                                />
                            </div>
                            : ''
                        }
                    </MenuItem>
                    : ''
                }
                {showInput ?
                    <MenuItem className='removeHover' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} disableRipple={true} >
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', margin: '0px 10px' }}>
                            <MInputTextField
                                secondColor={"var(--color-black)"}
                                color={color}
                                label={`${t('Name')}`}
                                type={"text"}
                                onChange={(e) => setNewView(e.target.value)}
                            />
                        </div>
                    </MenuItem>
                    : ''
                }
            </div>
        </Menu >
    )
}

AdvanceFilter.propTypes = {
    metaPair: PropTypes.array,
    metaType: PropTypes.array,
    onAddMetaPair: PropTypes.func,
    onSubmitFilters: PropTypes.func,
    onDeleteFilter: PropTypes.func,
    onDeleteAllFilters: PropTypes.func,
    anchorAF: PropTypes.oneOfType([
        PropTypes?.object,
        PropTypes?.element,
    ]),
    setAnchorAF: PropTypes.func,
    onSaveFilter: PropTypes.func,
    views: PropTypes.object,
    onToasts: PropTypes.func,
    color: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
    ]),
    colorOptions: PropTypes.object,
    removeColumns: PropTypes.array,
    removeFilters: PropTypes.array
}

